import { axiosGet } from '../axios/httpRequest';

/**
 * 获取工作台统计数据
 * @param {number} days - 统计周期（7、30、90天）
 * @returns {Promise} 返回统计数据
 */
export const getDashboardStatistic = (days = 7) => {
    return axiosGet('api/dashboard/v1/statistic', { days });
};
